import React from 'react';
import { EnlargedImageModal } from './EnlargedImageModal';
import { GuestCheckoutPrompt } from '../../components/GuestCheckoutPrompt';
import { CustomQuoteModal } from '../../components/CustomQuoteModal';
import { QuoteSubmittedToast } from '../../components/QuoteSubmittedToast';
import { PlaceOrderLoadingOverlay } from '../../components/PlaceOrderLoadingOverlay';

/**
 * All top-level overlays / modals owned by QuoteCalculator:
 *
 *   - EnlargedImageModal — full-screen preview image lightbox
 *   - GuestCheckoutPrompt — shown when an anonymous visitor clicks Place Order
 *   - CustomQuoteModal — in-app form for products that require a quote
 *     (replaces the legacy mailto flow)
 *   - QuoteSubmittedToast — 5-second success toast after the modal closes
 *   - PlaceOrderLoadingOverlay — branded "do not refresh" full-screen overlay
 *     shown the instant Place Order is clicked. Prevents the "did it freeze?"
 *     double-click that previously produced duplicate drafts in the wild.
 *
 * Purely presentational — the parent owns all state and handlers.
 */
export const QuoteModalsContainer = ({
  // Enlarged image
  imageEnlarged,
  enlargedImageSrc,
  handleCloseEnlargedImage,
  // Guest prompt
  guestPromptOpen,
  setGuestPromptOpen,
  setPendingPlaceOrder,
  // Custom quote
  customQuoteOpen,
  setCustomQuoteOpen,
  customQuotePrefill,
  quoteSentToastOpen,
  setQuoteSentToastOpen,
  // Place-order loading
  placingOrder,
}) => (
  <>
    <EnlargedImageModal
      open={imageEnlarged}
      src={enlargedImageSrc}
      onClose={handleCloseEnlargedImage}
    />

    <GuestCheckoutPrompt
      open={guestPromptOpen}
      onClose={() => setGuestPromptOpen(false)}
      onContinue={() => {
        // Flag the intent — a useEffect will retry handlePlaceOrder once
        // AuthContext commits the freshly-signed-up guest user.
        setPendingPlaceOrder(true);
      }}
    />

    <CustomQuoteModal
      open={customQuoteOpen}
      onClose={() => setCustomQuoteOpen(false)}
      onSubmitted={() => {
        setCustomQuoteOpen(false);
        setQuoteSentToastOpen(true);
      }}
      prefill={customQuotePrefill}
    />
    <QuoteSubmittedToast
      open={quoteSentToastOpen}
      onClose={() => setQuoteSentToastOpen(false)}
    />

    <PlaceOrderLoadingOverlay open={placingOrder} />
  </>
);

export default QuoteModalsContainer;
